export default __webpack_public_path__ + "c8ec38f89f9eaef717e57597c26788a0.png";